import api from "@/services/api";

export default {
  getList(params) {
    return api.get("/report/asset-with-number", { params });
  },
  exportExcel(params) {
    return api.get("/report/asset-with-number/export-excel", {
      params,
      responseType: "blob",
    });
  },
};
